import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class ThreadGrid extends BaseComponent {
	
	static get properties() {
		return {	
			nodeId: {type: String}
		};
	}
	
	constructor() {
		super();
		
		var threadGrid = this;
		setTimeout(function(){
			threadGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var threadGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'vaadin-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:eye', ' View Details')
					], 
					listeners: {
						click: function() {
							actionView(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',						
					theme: 'error primary',
					itemid: 'delete',
					disabled: true,
					'class': 'spacer-toolbar-item',
					style: 'float: right;',
					permissions: ['ADMIN_SYSTEM:DELETE'],
					children:[
						ElementUtil.makeIcon('vaadin:sword', ' Interrupt')
					],
					listeners: {
						click: function() {
							actionInterrupt(grid.selectedItems[0]);
						}
					}
				}				
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed': function(event) {
						//handle local sort; since the grid doesn't provide the sorted data
						if (event.detail.value) {
							var sortField = event.target.path;
							
							threadGrid.fullDataSet = threadGrid.fullDataSet.sort(function(a, b){
								var itemA = a[sortField].toUpperCase();
								var itemB = b[sortField].toUpperCase();
								if (event.detail.value !== 'asc') {
									var temp = itemA;
									itemA = itemB;
									itemB = temp;
								}								
								if (itemA < itemB) {
									return -1;
								}
								if (itemA > itemB) {
									return 1;
								}
								return 0;								
								
							});
							
							
						}
					}
				}
			},			
			children: [				
				{						
					path: 'name',
					header: 'Name',
					sortField: 'name',
					width: '5em'
				},
				{						
					path: 'status',
					header: 'Status',
					sortField: 'status',
					width: '5em'
				},
				{
					path: 'details',
					header: 'Details',
					sortField: 'details',
					'flex-grow': '1'					
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {
						ElementUtil.query(toolbar, 'view').disabled = false; 
						ElementUtil.query(toolbar, 'delete').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'view').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;
					}	
				}
			}
		});	
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid
			]
		});		
		threadGrid.append(flexLayout);		
		
		
		var actionRefresh = function() {
			var loadMask = threadGrid.showLoading();	
			Service.getNodeService().getThreads(threadGrid.nodeId).then(function(threads){
				loadMask.remove();
				threadGrid.fullDataSet = threads;
				
				grid.activeItem = null;
				grid.items = threads;				
			});					
			
		};
		actionRefresh();
		
		var actionView = function(record) {
			
			var viewWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Thread Details',
				icon: 'lumo:eye',
				listeners: {
					ready: function() {
						
						viewWin.show();
						
						var displayDetails = function(inputRecord) {
							var loadMask = details.showLoading();
							Service.getNodeService().getThreadDetails(threadGrid.nodeId, inputRecord.id).then(function(detailInfo){
								loadMask.remove();								
								
								detailInfo = '<h2>Thread: ' + record.name + '</h2>' + detailInfo;								
								ElementUtil.query(details, 'display').innerHTML = detailInfo;								
							}, function(){
								loadMask.remove();
							});
						};
						
						var details = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								{
									tag: 'div',
									itemid: 'display',
									style: 'height: 100%; padding-top: 10px;',
									slot: 'primary',
									innerHTML: ''
								},
								{
									tag: 'dl-nextprev-toolbar',	
									itemid: 'nextPrev',
									slot: 'footer',
									listeners: {
										ready: function(event){
											event.target.updateData(threadGrid.fullDataSet);
											event.target.setSelectedRecord('id', record.id);
										},
										change: function(event) {
											grid.deselectItem(record);
											grid.selectItem(event.detail.item);
											record = event.detail.item;
											displayDetails(record);	
										}										
									}
								}
							]
						});
						viewWin.addToContentElement(details);
						displayDetails(record);
						
					}
				}
			});			
			
		};
		
		var actionInterrupt = function(record) {
			
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Interrupt',
				message: 'Are you sure you want to interrupt: <b>' + record.name + '</b>? <br> <br> (This will attempt to stop the process or force it to jump state.<br>Some process may not be interruptable.)',				
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = threadGrid.showLoading('Interrupting ' + record.name);
							Service.getNodeService().threadInterrupt(threadGrid.nodeId, record.id).then(function(detailInfo){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Interrupted: ' + record.name, {									
									theme: 'success'
								});
								actionRefresh();
							});							
						}
					},
					{
						text: 'No'
					}
				]
			});				
			
		};
		
	}
	
};
customElements.define('dl-thread-grid', ThreadGrid);
